import React, {useRef, useState} from 'react';
import { createPortal } from "react-dom";
 
// Ensure modal-root exists in the DOM
const getModalRoot = () => {
  let el = document.getElementById("modal-root");
  if (!el) {
    el = document.createElement("div");
    el.id = "modal-root";
    document.body.appendChild(el);
  }
  return el;
};
 
const Tooltip = ({ content, children }) => {
  const [coords, setCoords] = useState(null);
  const triggerRef = useRef(null);
 
  const showTooltip = () => {
    const rect = triggerRef.current.getBoundingClientRect();
    if (!rect) return;
    setCoords({
      top: rect.bottom + window.scrollY + 4,        // 8px below the element
      left: rect.left + window.scrollX + rect.width / 2, // horizontally centered
    });
  };
 
  const hideTooltip = () => setCoords(null);
 
  return (
    <>
      <div
        ref={triggerRef}
        style={{ display: "inline-block" }}
        onMouseEnter={showTooltip}
        onMouseLeave={hideTooltip}
      >
        {children}
      </div>
 
      {coords && createPortal(
        <div style={{
            position: "absolute",
            top: coords.top,
            left: coords.left,
            transform: "translateX(-50%)",
            color: "#000000",
            zIndex: 9999,
            cursor: "pointer",
            fontSize: "16px",
            background: "#FFFFFF",
            boxShadow: "0 3px 6px #33333326",
            padding: "calc(var(--dsp-space) * 2) calc(var(--dsp-space) * 4)",
            borderRadius: "4px"

        }}>
          {content}
        </div>,
        getModalRoot()
      )}
    </>
  );
};

export default React.memo(Tooltip);